import { authedAtTimestampAtom } from "../../auth/state";
import { useCallback } from "react";
import { useAtomCallback } from "jotai/utils";
import { useAtomValue } from "jotai";

export const useGetAuthedAtTimestamp = () => {
  const getAuthedAtTimestamp = useAtomCallback(
    useCallback((get) => get(authedAtTimestampAtom), []),
  );
  const authedAtTimestamp = useAtomValue(authedAtTimestampAtom);

  return [authedAtTimestamp, getAuthedAtTimestamp];
};
